import { ArchiveConfirmationDialog } from 'v5/patterns/entity-list/ArchiveConfirmationDialog';

export interface ArchivedBannerProps {
  onUnarchive: () => Promise<void>;
  assetName: string;
}

export function ArchivedBanner({
  onUnarchive,
  assetName
}: ArchivedBannerProps) {
  return (
    <div className="tailwind-root">
      <div className="relative w-full">
        <div className="flex items-center justify-between w-full bg-red-100 text-red-600 font-normal py-2 px-4 rounded-none">
          <span>This {assetName} has been archived</span>
          <ArchiveConfirmationDialog
            isArchived={true}
            entityName={assetName}
            onConfirm={onUnarchive}
            unarchiveTitle={`Unarchive ${assetName}?`}
            trigger={
              <button
                type="button"
                className="underline text-red-600 hover:opacity-70 focus-visible:ring-2 focus-visible:ring-red-600 px-0.5 ml-auto font-normal bg-transparent border-none cursor-pointer"
              >
                Unarchive
              </button>
            }
          />
        </div>
      </div>
    </div>
  );
}
